import React, { useEffect } from 'react';
import ProtectedRoute from './PrivateRoutes';
import { routes as appRoutes } from '.';
import { useSelector } from "react-redux";
import { Route, Routes, useLocation } from 'react-router-dom';
import { get_auth_user_data } from '../redux/auth/auth.selectors';
import { mixpanelAppRegister, mixpanelPathnameEvent } from '../mixPanelFunctions/mixPanelFunctions';

const AppRoutes = () => {
  const { auth } = useSelector((state) => state);
  const user_data = useSelector(get_auth_user_data);
  const role = user_data?.role || "guest";
  // console.log(role);
  const defaultProtectedRouteProps = {
    isAuthenticated: !!auth.isAuth,
    authenticationPath: '/login',
  };
 useEffect(()=>{
   const selectedClient = localStorage.getItem("client_id")
   if(auth.isAuth && selectedClient){
    mixpanelAppRegister(user_data?.email,user_data?.name,user_data?.role,selectedClient) // mixpanel register function
   }
 },[auth])
 
  const pageLocation = useLocation();
  const {  pathname } = pageLocation;

  useEffect(() => { 
    let str = pathname?.split('/')?.slice(1)?.join(' ') || "home";
    mixpanelPathnameEvent(str);
  }, [pathname]);

  return (
    <Routes>
      {
        appRoutes.filter(item => item.role?.includes(role)).map((route) => {
          if (route.Routes) {
            return (
              <Route
                key={route.key}
                path={route.path}
                element={route?.protected ? <ProtectedRoute {...defaultProtectedRouteProps} outlet={<route.component />} /> : <route.component />}
              >
                {route.Routes.map(subRoute => (
                  <Route
                    key={subRoute.key}
                    path={subRoute.path}
                    element={<subRoute.component />}
                  />
                ))}
              </Route>
            );
          }
          return (
            <Route
              key={route.key}
              path={route.path}
              element={route?.protected ? <ProtectedRoute {...defaultProtectedRouteProps} outlet={<route.component />} /> : <route.component />}
            />
          );
        })
      }
      {
        appRoutes.filter(item => item.role === "all").map((route) => {
          if (route.Routes) {
            return (
              <Route
                key={route.key}
                path={route.path}
                element={route?.protected ? <ProtectedRoute {...defaultProtectedRouteProps} outlet={<route.component />} /> : <route.component />}
              >
                {route.Routes.map(subRoute => (
                  <Route
                    key={subRoute.key}
                    path={subRoute.path}
                    element={<subRoute.component />}
                  />
                ))}
              </Route>
            );
          }
          return (
            <Route
              key={route.key}
              path={route.path}
              element={route?.protected ? <ProtectedRoute {...defaultProtectedRouteProps} outlet={<route.component />} /> : <route.component />}
            />
          );
        })
      }
    </Routes>
  );
};

export default AppRoutes;